import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const customStyles = {
  option: (provided) => ({
    ...provided,
    padding: '5px 10px',
  }),
  container: () => ({
    // none of react-select's styles are passed to <Control />
    flex: '1',
    minWidth: 200,
    marginRight: 10,
  }),
  control: () => ({
    // none of react-select's styles are passed to <Control />
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    borderBottom: '1px solid #848484',
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  },
  menu: (provided) => ({
    ...provided,
    margin: '-9px 0 0 0',
    border: '1px solid #848484',
    borderRadius: 0,
    padding: 0,
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0,
    height: '34px',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#000',
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: 'none',
  }),
};

function BtnAddGroup({ onBtnClick, options, isDisabled, placeholder, noOption, placement }) {
  const { t } = useTranslation('common');

  return (
    <button type="button" className="filter-btn filter-button_add_colour_group" disabled={isDisabled} title={t('APPROVE_REJECTS.ADD_TO_GROUP')}>
      <OverlayTrigger
        placement={placement || 'bottom'}
        trigger="click"
        rootClose
        overlay={
          <Popover className="custom-popover w-320-popover">
            <Popover.Content>
              <div className="filter-add-group-container">
                <Select
                  options={options}
                  getOptionLabel={(option) => `${option.name}`}
                  getOptionValue={(option) => `${option._id}`}
                  onChange={onBtnClick}
                  styles={customStyles}
                  placeholder={placeholder}
                  noOptionsMessage={() => noOption}
                  classNamePrefix="common-select"
                  className="common-select"
                  menuPlacement={placement || 'bottom'}
                />

                <button type="button" onClick={() => onBtnClick('add')} className="btn btn-outline">
                  <i className="icon-add f-24" />
                </button>
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <i className="icon-add_to_colour_group f-24" />
      </OverlayTrigger>
      <span className="text-icon">{t('APPROVE_REJECTS.GROUP')}</span>
    </button>
  );
}

export default BtnAddGroup;
